import api from './api';

export const notificationService = {
  async getNotifications(params = {}) {
    const response = await api.get('/notifications', { params });
    return response.data;
  },
  
  async getUnreadCount() {
    const response = await api.get('/notifications/unread-count');
    return response.data.data.count;
  },
  
  async markAsRead(id) {
    const response = await api.patch(`/notifications/${id}/read`);
    return response.data.data;
  },
  
  async markAllAsRead() {
    const response = await api.post('/notifications/mark-all-read');
    return response.data;
  },
  
  async deleteNotification(id) {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },
  
  async deleteAll() {
    const response = await api.delete('/notifications');
    return response.data;
  }
};
